import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../redux/store'
import { Company } from './models/company'

export enum CompanyFilterType {
    q = 'q',
}
export type CompanyFilters = {
    q?: string
}
type CompaniesState = {
    selectedItems: Company[]
    filters: CompanyFilters
}

const slice = createSlice({
    name: 'companies',
    initialState: { selectedItems: [], filters: {} } as CompaniesState,
    reducers: {
        setSelectedItems: (state, { payload }: PayloadAction<Company[]>) => {
            state.selectedItems = payload
        },
        setFilters: (state, { payload }: PayloadAction<{ filter: CompanyFilterType; value: any }>) => {
            state.filters[payload.filter] = payload.value
        },
    },
})

export const selectSelectedCompanies = (state: RootState) => state.companies.selectedItems
export const selectCompanyFilters = (state: RootState) => state.companies.filters

export default slice.reducer

export const companiesActions = slice.actions
